import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { LogOutIcon } from "lucide-react";
import { useSession } from "@/providers/SessionProvider";

export function NavUser() {
  const { logout, user } = useSession();
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="bg-transparent hover:bg-white/60 rounded-full p-1 h-auto gap-0"
            >
              <Avatar className="h-9 w-9 rounded-full ring-2 ring-white/80 shadow-sm">
                <AvatarImage src={user?.avatar} alt={user?.name} />
                <AvatarFallback className="rounded-full bg-primary text-white text-xs font-semibold">
                  {user?.name?.charAt(0)?.toUpperCase()}
                </AvatarFallback>
              </Avatar>
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="min-w-56 rounded-xl z-9999999 shadow-lg border-slate-200/80"
            side="bottom"
            align="end"
            sideOffset={8}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-3 px-3 py-3 text-left text-sm">
                <Avatar className="h-10 w-10 rounded-full shadow-sm">
                  <AvatarImage src={user?.avatar} alt={user?.name} />
                  <AvatarFallback className="rounded-full bg-primary text-white text-sm font-semibold">
                    {user?.name?.charAt(0)?.toUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <div className="grid flex-1 text-left leading-tight">
                  <span className="truncate font-semibold text-slate-900">
                    {user?.name}
                  </span>
                  <span className="truncate text-xs text-slate-500 mt-0.5">{user?.email}</span>
                  {user?.mobileNo && (
                    <span className="truncate text-xs text-slate-400">{user?.mobileNo}</span>
                  )}
                </div>
              </div>
            </DropdownMenuLabel>
            <div className="h-px bg-slate-100 mx-2" />
            <DropdownMenuItem onClick={logout} className="mx-1 my-1 rounded-lg text-red-600 focus:text-red-600 focus:bg-red-50">
              <LogOutIcon className="w-4 h-4" />
              Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
